import { gql } from '@apollo/client'

const SAVE_ACADEMY_RESOURCE_FOR_USER = gql`
  mutation saveAcademyResourceForUser(
    $academyResourceId: String!
    $userId: Int!
  ) {
    saveAcademyResourceForUser(
      academyResourceId: $academyResourceId
      userId: $userId
    ) {
      academyResourceId
      userId
    }
  }
`
export default SAVE_ACADEMY_RESOURCE_FOR_USER
